import React from "react";
import Ink from "react-ink";
// import { useSelector } from "react-redux";

// import * as INITIAL_DATA from "../../screens/Register/INITIAL_DATA";
import "./style.css";

export default (props) => {
  // const data =
  //   useSelector((store) => store.activationOptionModal.data) ||
  //   INITIAL_DATA.USER;

  const handlePress = (selectedOption) => {
    if (props.onOptionSelected) {
      props.onOptionSelected(selectedOption);
    }
  };

  return (
    <div className="activation-option-modal-container">
      <div className="activation-option-modal-box-container">
        <div className="activation-option-modal-header-container">
          <p>Successful</p>
        </div>
        <div className="activation-option-modal-content-container">
          <p>
            Activation link/token has been sent to your email address and phone
            number
          </p>
          <h2>Activate account through</h2>
          <div className="activation-option-modal-button-row-container">
            <div
              onClick={() => handlePress("link")}
              className="activate-option-button-container"
            >
              <p>Activation Link</p>
              <Ink />
            </div>
            <div
              onClick={() => handlePress("otp")}
              className="activate-option-button-container"
            >
              <p>OTP</p>
              <Ink />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
